import React from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt } from 'react-icons/fa';
import './DatePicker.css'; // We'll create this file next

const CustomDatePicker = ({
  selected,
  onChange,
  placeholderText = "Select date",
  minDate = null,
  maxDate = null,
  className = "",
  disabled = false,
  showTimeSelect = false,
  dateFormat = "dd/MM/yyyy",
  timeFormat = "HH:mm",
  timeIntervals = 30,
  timeCaption = "Time",
  showIcon = true,
  label = null,
  error = null,
  ...props
}) => {
  return (
    <div className="w-full datepicker-container">
      <div className="relative">
        <DatePicker
          selected={selected}
          onChange={onChange}
          placeholderText={placeholderText}
          minDate={minDate}
          maxDate={maxDate}
          disabled={disabled}
          showTimeSelect={showTimeSelect}
          dateFormat={showTimeSelect ? `${dateFormat} ${timeFormat}` : dateFormat}
          timeFormat={timeFormat}
          timeIntervals={timeIntervals}
          timeCaption={timeCaption}
          className={`w-full h-10 px-3 py-2 border border-gray-200 rounded-lg text-[#374151] placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-transparent ${className} ${error ? 'border-red-500' : ''}`}
          {...props}
        />
        {showIcon && (
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
            <FaCalendarAlt className="h-5 w-5 text-gray-400" />
          </div>
        )}
      </div>
      {error && (
        <p className="mt-1 text-sm text-red-500">{error}</p>
      )}
    </div>
  );
};

export default CustomDatePicker; 